import { exitIframe } from "@client/lib/misc";
import { type AppState } from "@client/types";
import { getIsIframed } from "@common/lib/url";
import { type OptInFormV2 } from "./types";

export const processEnroll = (state: AppState, enroll: OptInFormV2.Api.ProgramEnroll | null): boolean => {
  if (enroll && !enroll.isMembership && getIsIframed()) {
    exitIframe({ reason: "membership_disabled", programId: enroll.programId });
    return true;
  }

  return false;
};
